import { useEffect } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { useTranslation } from 'react-i18next';
import { CustomerInfo, CustomerLoginInfo } from 'orderme-api-integration-client';
import { Box, Stack, Typography } from '@mui/material';

export function CustomerDetails() {
  const customerInfo: CustomerInfo = useAppSelector((state: RootState) => state.customerState.customerInfo);
  const loginInfo: CustomerLoginInfo = useAppSelector((state: RootState) => state.customerState.loginInfo);
  const { t } = useTranslation();

  useEffect(() => {}, []);

  return (
    <>
      <Stack spacing={1}>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {t('payment:customer')}
          </Typography>
          <Typography variant="body2">{customerInfo?.name + ' ' + customerInfo?.surname}</Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {t('account:email')}
          </Typography>
          <Typography sx={{ overflowWrap: 'anywhere' }} variant="body2">
            {loginInfo?.email || '-'}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {t('account:phoneNumber')}
          </Typography>
          <Typography variant="body2">{loginInfo?.phone || '-'}</Typography>
        </Box>
      </Stack>
    </>
  );
}
